import React, { useEffect } from "react";
import Select from "react-select";
import ErrorContainer from "./ErrorContainer";

const MultiSelect = ({
  label,
  localStateValue,
  setLocalStateMethod,
  optionsArray,
  formRegister,
  formFieldSetMethod,
  getFieldValues,
  horizontal = false,
  formKey,
  formError,
  //
  dynamicModalElementInfo,
  setModalInfo,
  dynamicModalInfo,
  extraClass="",
  innerDivClass="",
}) => {
  useEffect(() => {
    console.log("1abcd", finalArray, localStateValue);

    if (localStateValue === "") return;
    const finalArray = localStateValue?.map((el) => el.value);
    console.log("2abcd", finalArray, localStateValue);
    formFieldSetMethod(formKey, finalArray);
  }, [localStateValue]);

  function handleOptions(selectedOption, localStateValue, setLocalStateMethod) {
    console.log("pppppp", "ancd");
    const selectAll = selectedOption.find((option) => option.value === "");
    if (selectAll) {
      if (localStateValue?.length === optionsArray.length - 1) {
        setLocalStateMethod("");
        formFieldSetMethod(formKey, " ");
      } else setLocalStateMethod(optionsArray.slice(1));
    } else {
      if (selectedOption.length === 0) {
        selectedOption = "";
        formFieldSetMethod(formKey, " ");
      }
      setLocalStateMethod(selectedOption);
    }
  }
  return (
    <li>
      <div class={`${extraClass} ${horizontal?"select-days":""}`}>
        <label className="required">{label}</label>
        <div class={`${innerDivClass} ${horizontal?"input-group select-div":""}`}>
          <Select
            {...formRegister(formKey)}
            isMulti
            value={localStateValue}
            options={optionsArray}
            onChange={(selectedOption) => {
              if (!dynamicModalElementInfo)
                handleOptions(
                  selectedOption,
                  localStateValue,
                  setLocalStateMethod
                );
              else {
                // setting for dynamic modal
                function setLocalStateMethod(value) {
                  const inputElementsArr = dynamicModalInfo?.modalElements?.map(
                    (element) => {
                      if (
                        element?.modalKey === dynamicModalElementInfo.modalKey
                      ) {
                        return {
                          ...dynamicModalElementInfo,
                          localStateValue: value,
                        };
                      } else return element;
                    }
                  );
                  setModalInfo({
                    ...dynamicModalInfo,
                    modalElements: inputElementsArr,
                  });
                }
                handleOptions(
                  selectedOption,
                  localStateValue,
                  setLocalStateMethod
                );
              }
            }}
          />
          {<ErrorContainer errors={formError} name={formKey} />}
        </div>
      </div>
    </li>
  );
};

export default MultiSelect;
